export class TextReadMoreModule {
    constructor() {

        this.toggleReadMoreButton();
    }

    toggleReadMoreButton() {

        $('.text-read-more').on("click", function (e) {

            e.preventDefault();
            var $button = $(this);
            var compId = $button.attr("data-comp-key");
            
            $(".limit-text-" + compId).hide();
            $(".full-text-" + compId).show();
        });

        $('.text-read-less').on("click", function (e) {

            e.preventDefault();
            var $button = $(this);
            var compId = $button.attr("data-comp-key");

            $(".limit-text-" + compId).show();
            $(".full-text-" + compId).hide();
        });
    }

}